import React, { useEffect } from "react";

declare global {
  interface Window {
    DG_CHAT_WIDGET_CONFIG: {
      env: string;
      widgetId: string;
    };
    dgchat: any;
  }
}

export const GeniusChat: React.FC = () => {
  useEffect(() => {
    window.DG_CHAT_WIDGET_CONFIG = {
      widgetId: "699528a4-ec0e-44ee-a054-a5a1a563d32b",
      env: "eu"
    };

    const geniusChatScript = document.createElement("script");
    geniusChatScript.defer = true;
    geniusChatScript.src = "https://chat.digitalgenius.com/init.js";
    geniusChatScript.integrity =
      "sha384-5oszRr5YQAgReCLbENEWNKVWjagnBVxP8iyy1nd1tq8VOgTPeIxgf8x0mOoDdXHN";
    geniusChatScript.crossOrigin = "anonymous";

    geniusChatScript.onload = () => {
      if (window.dgchat && typeof window.dgchat.init === "function") {
        window.dgchat.init();
      } else {
        console.error("Error: DG Chat initialization failed.");
      }
    };
    document.head.appendChild(geniusChatScript);
  }, []);

  return <div id="dg-chat-container" />;
};
